import List from '@monorepo/common/component/List';
import PersonNameLabel from '@monorepo/common/component/person/PersonNameLabel';
import QueryWithLoader from '@monorepo/common/component/QueryWithLoader';
import {
  ResponsiveContextProvider,
  ResponsiveDetailCol,
  ResponsiveListCol
} from '@monorepo/common/component/responsive/ResponsiveContextProvider';
import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { Container, Row } from 'reactstrap';
import PersonSwitchDetail from '../component/person/switch/PersonSwitchDetail';
import { FamilyDocument, FamilyQuery, FamilyQueryVariables } from '../graphql-operations';

export default function PersonsPage() {
  const { path: parentPath, url: parentUrl } = useRouteMatch();
  const path = `${parentPath}/:personId?`;
  const match = useRouteMatch<{ personId?: string }>(path);
  const personId = match?.params.personId;

  return (
    <Route path={path}>
      <QueryWithLoader<FamilyQuery, FamilyQueryVariables> query={FamilyDocument}>
        {({ data, loading, error }) => {
          const persons = data.family;
          const single = persons.length === 1;
          const resolvedPersonId = single ? persons[0].id : personId;

          return (
            <ResponsiveContextProvider single={single} selectedId={resolvedPersonId}>
              <Container>
                <Row>
                  <ResponsiveListCol>
                    <div className="position-fixed-scrollable">
                      <List
                        items={persons}
                        loading={loading}
                        error={error}
                        selectedId={personId}
                        idExtractor={person => person.id}
                        urlExtractor={person => `${parentUrl}/${person.id}`}
                      >
                        {person => <PersonNameLabel person={person} />}
                      </List>
                    </div>
                  </ResponsiveListCol>

                  <ResponsiveDetailCol>
                    <PersonSwitchDetail personId={resolvedPersonId} listUrl={parentUrl} />
                  </ResponsiveDetailCol>
                </Row>
              </Container>
            </ResponsiveContextProvider>
          );
        }}
      </QueryWithLoader>
    </Route>
  );
}
